<template>
  <ion-page>
    <ion-content>
      <ion-grid :style="{height: '100%'}">
        <ion-row class="ion-justify-content-center ion-align-items-center" :style="{height: '100%', textAlign: 'center'}">
          <ion-col size="12">
            <img :src="logoAsset" :style="{width: '85%', marginTop: '-40px', marginBottom: '-10px'}" alt="{{title}}" class="contain" />
            <br/>
            <ion-label>Iniciando</ion-label>
            <br/>
            <ion-spinner name="dots"></ion-spinner>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { 
  IonGrid,
  IonPage,
  IonContent,
  IonRow,
  IonCol,
  IonSpinner,
  IonLabel 
} from '@ionic/vue';
export default {
  name: 'Splash',
  components: {
    IonGrid,
    IonPage,
    IonContent,
    IonRow,
    IonCol,
    IonSpinner,
    IonLabel 
  },
  computed:{
    logoAsset(){
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? require("@/assets/logo.png") : require("@/assets/logo_dark.png")
    }
  }
}
</script>

<style>
ion-spinner {
  transform: scale(2);
}
</style>